import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'time',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class TimePipe implements PipeTransform {
  constructor(private readonly datePipe: DatePipe) {}

  transform(value: string, format: string): string | null {
    if (!value) {
      return null;
    }

    const date = new Date(`1970-01-01T${value}`);

    return isNaN(date.getTime()) ? null : this.datePipe.transform(date, format);
  }
}
